import { ReleaseStatus, TransactionType } from '@/types';
import { StepArchetype } from '@/types/stepRun';

export enum WorkflowRunUpdatable {
    TriggerBatchAction = 'TriggerBatchAction',
    PingPendingChecklistItemsForStepGroup = 'PingPendingChecklistItemsForStepGroup',
    BulkMarkCLIsAsCompleted = 'BulkMarkCLIsAsCompleted',
    UpdateDestinationStatuses = 'UpdateDestinationStatuses',
}

export interface TriggerBatchActionRequest {
    targetStepRunIds: string[];
    transactionType: TransactionType;
    stepArchetype: StepArchetype;
    customRequestData: any;
}

export interface PingPendingChecklistItemsForStepGroupRequest {
    stepRunIds: string[];
    stepArchetype: StepArchetype;
}

export interface BulkMarkCLIsAsCompletedRequest {
    stepRunIds: string[];
}

export interface DestinationStatusUpdate {
    destinationStepConfigId: string;
    status: ReleaseStatus;
}

export interface UpdateDestinationStatusesRequest {
    destinationUpdates: DestinationStatusUpdate[];
}
